import {RenewProjectFormValidationSchema} from '@/features/projects/formSchemas'
import {HttpGetProjectExtensionRequestDataResponse} from '@/features/projects/http/projects.http'
import {ProjectExtended} from '@/features/projects/types'
import {ensureWorkingDay} from '@/features/projects/utils'
import {zodResolver} from '@hookform/resolvers/zod'
import dayjs from 'dayjs'
import {ReactNode} from 'react'
import {FormProvider, useForm} from 'react-hook-form'

export const RenewProjectFormProvider = ({
    children,
    project,
    extensionRequestData,
    holidays
}: {
    children: ReactNode
    project: ProjectExtended
    extensionRequestData: HttpGetProjectExtensionRequestDataResponse
    holidays: {date: string}[]
}) => {
    const startDate = ensureWorkingDay(
        dayjs(extensionRequestData.startDate).add(extensionRequestData.durationDays).toDate(),
        holidays
    )
    const expirationDate = ensureWorkingDay(
        dayjs(startDate).add(extensionRequestData.durationDays, 'day').toDate(),
        holidays
    )

    console.log(
        'Added',
        extensionRequestData,
        dayjs(extensionRequestData.startDate).add(extensionRequestData.durationDays).toISOString()
    )

    const form = useForm<RenewProjectFormValidationSchema>({
        mode: 'onBlur',
        resolver: zodResolver(RenewProjectFormValidationSchema),
        defaultValues: {
            id: project.id,
            patient: {
                id: project.patient?.id,
                fullName: project.patient?.fullName,
                serviceType: project.patient?.serviceType
            },
            referringProject: project,
            sector: extensionRequestData.sector,
            assistiveRegime: project.assistiveRegime || undefined,
            startDate,
            expirationDate,
            durationDays: extensionRequestData.durationDays,
            sender: project.sender || undefined,
            specialist: project.specialist || undefined
        }
    })

    return <FormProvider {...form}>{children}</FormProvider>
}
